export const faqHero = {
  title: "Frequently asked questions",
  subtitle: "Everything you need to know before your first visit",
};

export const faqItems = [
  {
    question: "Do I need to bring anything?",
    answer:
      "No — everything is provided at the station. Shampoo, warm rinse, conditioner, anti-flea treatment, and blow dry are all built in. Just bring your dog!",
  },
  {
    question: "What size dogs can use Pawwash?",
    answer:
      "Our tubs are designed to accommodate most breeds, from small dogs to large breeds. The self-serve tubs are spacious enough for comfortable washing at any size.",
  },
  {
    question: "Is it really 24/7?",
    answer:
      "Yes — participating Pawwash locations are open 24 hours a day, 7 days a week. Visit the home page to find your nearest station and confirm opening hours.",
  },
  {
    question: "How long does a wash take?",
    answer:
      "Each session is £10 for 10 minutes of washing time. That covers shampoo, rinse, conditioner, blow dry, and tub disinfect — most dogs are done within the session.",
  },
  {
    question: "How do I pay?",
    answer:
      "Card only — pay at the station when you arrive. No booking or pre-payment required.",
  },
  {
    question: "How much does a Pawwash dog wash cost in Glasgow?",
    answer:
      "£10 for 10 minutes — a flat rate at all Pawwash stations in Glasgow and across Scotland. The price includes shampoo, rinse, conditioner, blow dry, and tub disinfect.",
  },
  {
    question: "Where are Pawwash stations in Scotland?",
    answer:
      "Pawwash stations are located at Speed Queen laundry sites across Glasgow and Scotland. Visit our home page to search by postcode or use your location to find the nearest station.",
  },
  {
    question: "Do I need to book a Pawwash appointment?",
    answer:
      "No — Pawwash is walk-in only. Simply find your nearest station, pay at the machine when you arrive, and start washing. No booking or pre-payment is required.",
  },
  {
    question: "Is Pawwash good for large dogs?",
    answer:
      "Yes — Pawwash tubs are designed for most breeds including large dogs. The self-serve tubs are spacious enough for comfortable washing at any size.",
  },
  {
    question: "What products are included at Pawwash?",
    answer:
      "Every session includes professional-grade shampoo, warm rinse, conditioner, anti-flea treatment, and blow dry. All products are built into the station — you do not need to bring anything.",
  },
  {
    question: "How is the tub cleaned between dogs?",
    answer:
      "After each wash, you rinse and disinfect the tub as the final step. This quick clean-up ensures the station is ready for the next user and is part of the built-in process.",
  },
];

export const faqMeta = {
  title: "FAQ | Pawwash",
  description:
    "Common questions about Pawwash self-serve dog wash stations — what to bring, dog sizes, 24/7 access, pricing in Glasgow, and how to pay.",
  path: "/faq",
};
